import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MaterialModule } from "src/app/app.materials";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-model-card",
  templateUrl: "./model-card.component.html",
  styleUrls: ["./model-card.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, RouterModule],
  standalone: true,
})
export class ModelCardComponent {
  @Input() model: any;
  @Input() superAdmin = false;
}
